// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layoutMenuBar {
  background-color: #f8fafb;
  height: 65px;
  display: flex;
  flex-direction: row;
  padding: 0 20px;
  align-items: center;
  column-gap: 16px;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-color: rgba(30, 53, 101, 0.1019607843);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.layoutMenuSideBar {
  background-color: #f8fafb;
  height: calc(100vh - 65px - 24px);
  min-width: 64px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;
  position: fixed;
  top: 65px;
  left: 0;
}

.layoutOutlet {
  position: fixed;
  top: 65px;
  left: 96px;
  right: 10px;
  bottom: 10px;
  width: calc(100% - 96px - 40px);
  padding: 20px;
  overflow-y: scroll;
  scrollbar-width: thin;
}

.menuIcon, .activeMenuIcon, .inActiveMenuIcon {
  width: 32px;
  height: 32px;
}

.activeMenuIcon {
  fill: #1e3565;
}`, "",{"version":3,"sources":["webpack://./src/styles/layout.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAQA;EACE,yBCPoB;EDQpB,YARoB;EASpB,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,wBAAA;EACA,6CCfY;EDgBZ,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAPF;;AAUA;EACE,yBCzBoB;ED0BpB,iCAAA;EACA,eAzBiB;EA0BjB,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAlCoB;EAmCpB,OAAA;AAPF;;AAUA;EACE,eAAA;EACA,SAxCoB;EAyCpB,UAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EAGA,aAAA;EACA,kBAAA;EACA,qBAAA;AATF;;AAYA;EACE,WCvDa;EDwDb,YCxDa;AD+Cf;;AAgBA;EAEE,aChEoB;ADkDtB","sourcesContent":["@use \"./variables\" as vars;\n\n$menuHeaderBarHeight: 65px;\n$menuHeaderXAxisPadding: 20px;\n$menuSideBarWidth: 64px;\n$menuSideBarYAxisPadding: 24px;\n$menuBarSideBarXAxisPadding: 16px;\n\n.layoutMenuBar {\n  background-color: vars.$menuBackGroundColor;\n  height: $menuHeaderBarHeight;\n  display: flex;\n  flex-direction: row;\n  padding: 0 $menuHeaderXAxisPadding;\n  align-items: center;\n  column-gap: 16px;\n  justify-content: space-between;\n  border-bottom: 1px solid;\n  border-color: vars.$borderColor;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.layoutMenuSideBar {\n  background-color: vars.$menuBackGroundColor;\n  height: calc(100vh - $menuHeaderBarHeight - $menuSideBarYAxisPadding);\n  min-width: $menuSideBarWidth;\n  padding: $menuSideBarYAxisPadding $menuBarSideBarXAxisPadding;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 24px;\n  position: fixed;\n  top: $menuHeaderBarHeight;\n  left: 0;\n}\n\n.layoutOutlet {\n  position: fixed;\n  top: $menuHeaderBarHeight;\n  left: calc($menuSideBarWidth + 2 * $menuBarSideBarXAxisPadding);\n  right: 10px;\n  bottom: 10px;\n  width: calc(\n    100% - calc($menuSideBarWidth + 2 * $menuBarSideBarXAxisPadding) - 40px\n  );\n  padding: 20px;\n  overflow-y: scroll;\n  scrollbar-width: thin;\n}\n\n.menuIcon {\n  width: vars.$menuIconSize;\n  height: vars.$menuIconSize;\n}\n\n.inActiveMenuIcon {\n  @extend .menuIcon;\n}\n\n.activeMenuIcon {\n  @extend .menuIcon;\n  fill: vars.$activeMenuIconColor;\n}\n","$menuIconSize: 32px;\n$activeMenuIconColor: #1e3565;\n$menuBackGroundColor: #f8fafb;\n$borderColor: #1e35651a;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
